export default __webpack_public_path__ + "images/6d2aed1f64c83e4caf1e93470b3ed2fc-medical.jpg";